import { render, staticRenderFns } from "./DepartamentoPessoalHoraExtra.vue?vue&type=template&id=3fb59a69"
import script from "./DepartamentoPessoalHoraExtra.vue?vue&type=script&lang=js"
export * from "./DepartamentoPessoalHoraExtra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports